module.exports = __webpack_public_path__ + "img/PL08455.5bee8c11.png";